var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFooter, ModalHeader, Form } from 'reactstrap';
import { Button, Spinner } from "./index";
const ModalDefault = (_a) => {
    var { isOpen, children, className, title, buttonCancelText = 'Отмена', buttonActionText = 'ОК', onActionClick = () => {
    }, onCancelClick = () => {
    }, disableActionButtonAutoFocus = false, withForm = true, inProgress } = _a, restProps = __rest(_a, ["isOpen", "children", "className", "title", "buttonCancelText", "buttonActionText", "onActionClick", "onCancelClick", "disableActionButtonAutoFocus", "withForm", "inProgress"]);
    const onFormSubmit = (event) => {
        event.preventDefault();
        onActionClick();
    };
    return (_jsxs(Modal, Object.assign({ autoFocus: false, isOpen: isOpen, className: className, toggle: onCancelClick }, restProps, { children: [inProgress && _jsx(Spinner, { size: "4x" }), withForm ? _jsxs(Form, { onSubmit: onFormSubmit, children: [title && _jsx(ModalHeader, { toggle: onCancelClick, children: title }), _jsx(ModalBody, { children: children }), _jsxs(ModalFooter, { children: [_jsx(Button, { color: "secondary", onClick: onCancelClick, children: buttonCancelText }), ' ', _jsx(Button, { type: "submit", color: "primary", autoFocus: !disableActionButtonAutoFocus, children: buttonActionText })] })] }) :
                _jsxs("div", { children: [title && _jsx(ModalHeader, { toggle: onCancelClick, children: title }), _jsx(ModalBody, { children: children })] })] })));
};
export default ModalDefault;
